import script from "./ElementOpacity.vue?vue&type=script&lang=ts&setup=true"
export * from "./ElementOpacity.vue?vue&type=script&lang=ts&setup=true"

import "./ElementOpacity.vue?vue&type=style&index=0&id=22345a51&lang=scss&scoped=true"

import exportComponent from "/Users/foresight/Desktop/foresight/web/PPTist-tauri/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-22345a51"]])

export default __exports__